export const environment = {
  production: false,
  environmentName: 'development',
  apiBaseUrl: 'https://dev-api.stronx.app/api',
};
